(function () {
  'use strict';

  /* @ngdoc object
   * @name corePermissoes
   * @description
   *
   */
  angular
    .module('corePermissoes', [
      'headerModule',
      'stateUrlModule',
      'ngCookies',
      'ui.router',
      'ui.bootstrap',
      'blockUI',
      'flash',
      'angular-confirm',
      'angularMoment',
      'daterangepicker',
      'compartilhamentos',
      'perfis',
      'usuarios',
      'uos',
      'ui.select',
      'ngSanitize',
      'v3gWebComponents',
      'restangular',
      'newsModule',
      'ngStomp',
      'importacaoMotorista',
      'importacaoPontoReferencia',
      'veiculos',
      'VfiltroModule',
      'uppercased',
      'expurgo',
      'histExpurgo',
      'ui.utils.masks',
      'VtabelaModule',
      'enumModule',
      'FeatureFlagModule',
      'camadaValor',
      'pascalprecht.translate',
      'angulartics',
      'angulartics.google.analytics',
      'urlConfigModule',
      'httpServiceV3gModule',
      'ConstantModule',

      'v3gVeiculoModule',
      'motoristaModule',
      'documentoModule',
      'filtroAlertaModule',
      'diagnosticoModule',
      'sidebarMenuToggleModule',
      'uoModule',
      'uoArvoreNivelModule',
      'linkOnboardingModule',
      'v3gValidatorModule',
      'modalInfoConfirmModule',
      'v3gTrimbleFilters',
      'v3gAuthenticatorModule',
      'v3gHeaderModule',
      'AlertasModule',
      'SolucoesModule',
      'errorPageModule'
    ])
    .run(configureRestAngular)
    .run((Authenticator, $translate, StateUrlService) => {
      Authenticator.getUser().then(user => {
        $translate.use(user.idioma.toLowerCase());
        $translate.fallbackLanguage('pt_br');
      });
      StateUrlService.initInterceptBloqueioSolucao();
    })
    .run(['$rootScope', '$state', 'StateUrlService', 'Authenticator',
    ($rootScope, $state, StateUrlService) => {
      let stateChangeStart = $rootScope.$on('$stateChangeStart', (event, to, toParams, from) => {
            $state.previous = from;
          }),
          locationChangeSuccess = $rootScope.$on('$stateChangeSuccess', () => {
            StateUrlService.onPageLoad();
          });

      $rootScope.$on('$destroy', locationChangeSuccess);
      $rootScope.$on('$destroy', stateChangeStart);
    }])
    .factory('Usuarios', Restangular => {
      return Restangular.service('auth/usuario');
    })
    .config(configI18n);

  function configI18n($translateProvider) {
    $translateProvider.useStaticFilesLoader({
      prefix: `https://vfleets-i18n.s3.sa-east-1.amazonaws.com/latest/`,
      suffix: '.json'
    });
    $translateProvider.useSanitizeValueStrategy('sceParameters');
    $translateProvider.forceAsyncReload(true);
  }

  function configureRestAngular(Restangular, UrlConfigService, Authenticator) {
    Restangular.setBaseUrl(UrlConfigService.getApiGatewayUrl());
    Restangular.setDefaultHttpFields({
      withCredentials: true
    });
    Restangular.setFullRequestInterceptor((element, operation, route, url, headers, params, httpConfig) => {
      headers.Authorization = `Bearer ${Authenticator.keycloak.token}`;
      return {
        element: element,
        params: params,
        headers: headers,
        httpConfig: httpConfig
      };
    });
  }
}());
